<template>
<div class="error-component error-cant-reach-server card border-warning text-center">
  <div class="card-header bg-warning">
    เงินของคุณไม่เพียงพอ
  </div>
  <div class="card-body">   
    <p class="card-text">คุณต้องเติมเงินให้เพียงพอต่อค่าธรรมเนียมสำหรับดูเครดิต</p>
  </div>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
</style>
